var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabWrapper',[_c('v-container',[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","lg":"10"}},[_c('Datatable',{attrs:{"headers":_vm.headers,"items":_vm.history,"title":"History"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }